import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";
import { cardHeaderStyles, cardContentStyles } from "../../../theme/mixins";

export const ResponsesWrapper = styled.div`
  margin: 20px 0;
`;

export const Header = styled.div`
  ${cardHeaderStyles};
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.white};
`;

export const Content = styled.div`
  ${cardContentStyles};
  justify-content: space-between;
`;

export const HeaderItem = styled.div`
  flex: 1;
`;

export const ContentItem = styled.div`
  flex: 1;
  font-size: ${({ theme }) => theme.fontSize.large.desktop};

  ${mediaMaxWidth.tablet} {
    font-size: ${({ theme }) => theme.fontSize.large.mobile};
  }
`;
